/**
 * @file modules/restrictions_overflow.js
 * @description Toggles the "Read more" trigger for a clamped restrictions excerpt
 *              (.store-page-v2__restrictions-excerpt--clamped) based on whether it's
 *              ACTUALLY overflowing its 3-line clamp. A character-count heuristic
 *              can't predict this: whether text overflows 3 lines depends on
 *              rendered width, font, and word-wrap points, not length.
 *
 *              A ResizeObserver (not a window resize listener) watches the excerpt's
 *              own box directly, so it also re-checks on font-load reflows and zoom,
 *              not just viewport width changes. It fires an initial callback as soon
 *              as observe() is called, so this also covers the first render — no
 *              separate "run once on load" path is needed.
 */
const EXCERPT_SELECTOR = ".store-page-v2__restrictions-excerpt--clamped";
const TRIGGER_SELECTOR = ".store-page-v2__restrictions-more";

function syncTrigger(excerpt) {
  const trigger = excerpt.nextElementSibling;
  if (!trigger || !trigger.matches(TRIGGER_SELECTOR)) return;

  trigger.hidden = excerpt.scrollHeight <= excerpt.clientHeight;
}

export function initRestrictionsOverflow() {
  document.querySelectorAll(EXCERPT_SELECTOR).forEach((excerpt) => {
    const observer = new ResizeObserver(() => syncTrigger(excerpt));
    observer.observe(excerpt);
  });
}

if (typeof document !== "undefined") {
  document.addEventListener("DOMContentLoaded", initRestrictionsOverflow);
}
